import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

class Footer extends Component<any> {
  componentDidMount = () => {
    window.addEventListener("scroll", this.scrollFunction);
  };

  scrollFunction = () => {
    const scrollbutton: HTMLElement | null = document.getElementById("toTop");
    if (scrollbutton) {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        scrollbutton.style.display = "block";
      } else {
        scrollbutton.style.display = "none";
      }
    }
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  render() {
    const { match } = this.props;
    const { path } = match;
    return (
      <>        
        <footer className={`footer`}>
          <div className="copyright-text">
            <span className="cursor-pointer"><a href="/student/terms-conditions" className="copyright-text">Terms & Conditions</a> </span><span className="FooterBar">   |  </span><span className="cursor-pointer"> <a href="/student/privacy-policy" className="copyright-text"> Privacy Policy </a></span>    
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
